import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { getItinerariesApi, updateItineraryPublishApi } from '../../../services/AdminService';
import ItineraryItem from './components/ItineraryItem';
import Modal from 'react-bootstrap/Modal';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '../../../contexts/AuthProvider';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfDocument from '../../../components/pdf-view';
import html2canvas from 'html2canvas';
import { LoadingSpinnerDotted } from '../../../components/loading-spinner/Loader';
import { Alert } from 'react-bootstrap';

const ItineraryPreview = () => {
    const { currencyData, authed } = useAuth();
    const history = useHistory();
    const location = useLocation();
    const searchPrams = new URLSearchParams(location.search);
    const itineraryId = searchPrams.get("itineraryId") || "";
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPublish, setIsLoadingPublish] = useState(false);
    const [itineraryData, setItineraryData] = useState();
    const [messages, setMessages] = useState({ message: "", status: false });

    const getDaysPreviewData = async () => {
        setIsLoading(true);
        const Obj = {
            userId: authed.user._id,
            itineraryId: itineraryId,
            newCurrency: currencyData?.currency
        }
        await getItinerariesApi(Obj, async (res) => {
            // console.log("res getItinerariesApi ====", res);
            setIsLoading(false);
            if (res.status === 200) {
                setItineraryData(res.data.data);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                setItineraryData(null);
            }
        });
    }

    const handlePublishModalShow = (event) => {
        setShowPublishModal(true);
        formik.resetForm();
    }
    const handlePublishModalClose = (event) => {
        setMessages({ message: "", status: false });
        setShowPublishModal(false);
        setIsLoadingPublish(false);
        formik.resetForm();
    }
    const formik = useFormik({
        initialValues: {
            type_of_itinerary: ""
        },
        validationSchema: Yup.object({
            type_of_itinerary: Yup.string().required('Choose an itinerary type.'),
        }),
        onSubmit: async (values) => {
            //console.log(values)
            setIsLoadingPublish(true);
            const publishObj = {
                itineraryId: itineraryId,
                type_of_itinerary: values.type_of_itinerary,
            }
            await updateItineraryPublishApi(publishObj, async (res) => {
                // console.log("res updateItineraryPublishApi ====", res);
                setIsLoadingPublish(false);
                const { message } = res.data;
                if (res.status === 200) {
                    formik.resetForm();
                    setMessages((prev) => ({ ...prev, message: message, status: true }));
                    setShowPublishModal(false);
                    history.push({ pathname: '/admin/itineraries-list' });
                } else {
                    console.log(`Error: ${res.data || "An unexpected error occurred."}`);
                    if (message) {
                        setMessages((prev) => ({ ...prev, message: message, status: false }));
                    }
                }
            });
        }
    });

    const mapRef = useRef(null);
    const [screenshots, setScreenshots] = useState(null);

    const takeScreenshot = async () => {
        if (mapRef.current) {
            const canvas = await html2canvas(mapRef.current, { useCORS: true });
            setScreenshots(canvas.toDataURL("image/png"));
        }
    };

    // console.log("itineraryData==>", itineraryData);

    useEffect(() => {
        getDaysPreviewData();
    }, []);

    return (
        <>
            <div className="content-body">
                <ItineraryItem isLoading={isLoading} itineraryData={itineraryData} mapRef={mapRef} />
                {!isLoading && (
                    <>
                        {itineraryData && (
                            !itineraryData?.isPublish ?
                                <div className="form-btn-groups d-flex justify-content-end mt-4">
                                    <button type="button" className="btn btn-secondary-color btn-border-color" onClick={() => history.goBack()}><i className="bi bi-arrow-left"></i>&nbsp;&nbsp;Back</button>
                                    <button type="button" onClick={() => handlePublishModalShow()} className="btn btn-primary-color ms-3">Publish</button>
                                </div>
                                :
                                <div className="form-btn-groups d-flex justify-content-end mt-4">
                                    <button type="button" className="btn btn-secondary-color btn-border-color" onClick={() => history.push('/admin/itineraries-list')}><i className="bi bi-arrow-left"></i>&nbsp;&nbsp;Back</button>
                                    <PDFDownloadLink className="btn btn-primary-color ms-3" document={<PdfDocument itineraryData={itineraryData} authed={authed} currency={currencyData?.currency} mapImg={screenshots} />} fileName={"Itinerary" + new Date().getTime() + ".pdf"}>
                                        {({ blob, url, loading, error }) => (
                                            // <button onClick={takeScreenshot}>Export to PDF</button>
                                            "Export to PDF"
                                        )}
                                    </PDFDownloadLink>
                                </div>
                        )}
                    </>
                )}
            </div>
            {showPublishModal && (
                <Modal
                    show={showPublishModal}
                    onHide={handlePublishModalClose}
                    keyboard={false}
                    size="sm"
                    className="add-travellers-modal publish-modal-style"
                    centered
                >
                    <Modal.Body>
                        {!isLoadingPublish && messages?.message && (
                            <Alert variant={messages?.status ? "success" : "danger"}>
                                {messages?.message}
                            </Alert>
                        )}
                        <form onSubmit={formik.handleSubmit}>
                            <div className="d-col-radio-field flex-column align-items-start">
                                <div className="form-check me-0">
                                    <input className="form-check-input" onChange={formik.handleChange} onBlur={formik.handleBlur} name="type_of_itinerary" value="Public" type="radio" id="Public" />
                                    <label className="form-check-label" htmlFor="Public">
                                        <h6>Public</h6>
                                        <p>Your itinerary can be seen by any registered user on Travey Club. (No personal details will be visible).</p>
                                    </label>
                                </div>
                                <div className="form-check me-0">
                                    <input className="form-check-input" onChange={formik.handleChange} onBlur={formik.handleBlur} name="type_of_itinerary" value="Private" type="radio" id="Private" />
                                    <label className="form-check-label" htmlFor="Private">
                                        <h6>Private</h6>
                                        <p>Your itinerary can only be seen by you.</p>
                                    </label>
                                </div>
                            </div>
                            {formik.touched.type_of_itinerary && formik.errors.type_of_itinerary ? <p className='errors-msg'>{formik.errors.type_of_itinerary}</p> : null}
                            <div className="justify-content-end d-flex mt-3">
                                <button type="button" onClick={handlePublishModalClose} className="btn btn-secondary-color btn-border-color">Cancel</button>
                                <button type="submit" disabled={isLoadingPublish} className="btn btn-primary-color btn-border-color ms-2">{isLoadingPublish ? <LoadingSpinnerDotted /> : "Submit"}</button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
}

export default ItineraryPreview;